<template>
  <el-dialog
    :title="`Паспорт компании `"
    :visible="!!editOrg"
    :width="widthDialog"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <template v-if="!!editOrg" slot="title">
      <div class="c-dialog-head">
        <h3 class="c-dialog-head__title">
          {{ `Паспорт компании ${editOrg.short_name || ''}` }}
        </h3>
        <share-link-button :is-small-button="false" :id-org="12" />
      </div>
    </template>
    <div v-if="!!editOrg" class="u_org_modal">
      <el-row :gutter="24">
        <el-col :span="12">
          <p>
            ИНН: <b>{{ editOrg.inn || '(нет данных)' }}</b>
          </p>
          <p>
            ОГРН: <b>{{ editOrg.ogrn || '(нет данных)' }}</b>
          </p>
          <p>
            Дата создания: <b>{{ editOrg.created_at || '(нет данных)' }}</b>
          </p>
        </el-col>
        <el-col :span="12">
          <p>
            БИК Банка: <b>{{ editOrg.userOrg.bik || '(нет данных)' }}</b>
          </p>
          <p>
            Коресподентский счет:
            <b>{{ editOrg.userOrg.core_account || '(нет данных)' }}</b>
          </p>
          <p>
            Номер счета:
            <b>{{ editOrg.userOrg.checking_account || '(нет данных)' }}</b>
          </p>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <p>
            Название банка:
            <b>{{ editOrg.userOrg.name_bank || '(нет данных)' }}</b>
          </p>
          <p>
            Адрес: <b>{{ editOrg.address || '(нет данных)' }}</b>
          </p>
          <p>
            Название: <b>{{ editOrg.name || '(нет данных)' }}</b>
          </p>
        </el-col>
      </el-row>
      <el-row v-if="documents" class="u_doc_block">
        <el-col :span="12">
          <p>Документы ИНН</p>
          <upload-document-modal
            name-document="ИНН"
            :data-edit="documents.inn"
            :source-id="documents.inn.sourceId"
            :need-additional="false"
          />
        </el-col>
        <el-col :span="12">
          <p>Документы ОГРН</p>
          <upload-document-modal
            name-document="ОГРН"
            :data-edit="documents.ogrn"
            :source-id="documents.ogrn.sourceId"
            :need-additional="false"
          />
        </el-col>
      </el-row>
      <div slot="footer">
        <el-button v-if="!newContragent" type="info" @click="checkContr">
          Сделать контрагентом
        </el-button>
        <div v-if="newContragent">
          Добавление контрагента
          <new-contragents :org="editOrg" @edited="edited" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import NewContragents from '@/components/Contragents/NewContragents'
import ShareLinkButton from '@/components/Forms/ShareLinkButton'
import UploadDocumentModal from '@/components/Upload/UploadDocumentModal'

export default {
  name: 'OrgModal',
  components: { UploadDocumentModal, NewContragents, ShareLinkButton },
  props: {
    editOrg: {
      type: Object,
      default: () => {},
    },
    documents: {
      type: Object,
      default: () => {},
    },
    edited: {
      type: Function,
      default: () => {},
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      newContragent: false,
      organization: {
        organization_id: 0,
        is_approve: 0,
        contact_person: '',
        contact_phone: '',
        tax_system_type: 1,
        payment_period: '',
        working_hours: '',
        idle_pay: '',
        bik: '',
        name_bank: '',
        core_account: '',
        rs: '',
      },
      org: {
        organization: {},
      },
    }
  },
  computed: {
    needAdditional() {
      return this.canAction('additionalCompany')
    },
  },
  watch: {
    editOrg() {
      this.newContragent = false
    },
  },
  methods: {
    checkContr() {
      this.newContragent = true
    },
    beforeOpen() {
      const {
        organization_id,
        is_approve,
        contact_person,
        contact_phone,
        tax_system_type,
        payment_period,
        working_hours,
        idle_pay,
        bik,
        name_bank,
        core_account,
        checking_account,
      } = this.editOrg

      this.organization = {
        organization_id,
        is_approve,
        contact_person,
        contact_phone,
        tax_system_type,
        payment_period,
        working_hours,
        bik,
        name_bank,
        core_account,
        checking_account,
        idle_pay,
      }
      this.$emit('change-ogrn-sourceId', { id: this.editOrg.id })
      this.$emit('change-inn-sourceId', { id: this.editOrg.id })
      this.org = this.editOrg
      this.notes = ''
    },
    handleClose() {
      this.closeModal()
    },
  },
}
</script>

<style lang="sass">
.u_org_modal
  .u_doc_block
    border: 1px dashed #aaa
    background: #efefef
    margin-bottom: 20px
    padding: 0 15px 15px
</style>
